<template>
  <div class="zxBadge">
      <sup class="badge red" :class="[bgwidth, { dot: isDot }]" v-if="sum != 0">{{ isDot ? '' : sum }}</sup>
  </div>
</template>

<script>
export default {
    name: 'zxBadge',
    props: {
        num: Number,
        size: String,
        isDot: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        sum () {
            return this.num > 99 ? '99+' : this.num
        },
        bgwidth () {
            return !this.size ? 'small' : this.size
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.zxBadge {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    .badge {
        border-radius: $border-radius-full;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        box-shadow: $shadow-sm;
        border: 1px solid $white;
    }

    .red {
        color: $white;
        background-color: $primary-color;
    }

    .dot {
        width: 8px !important;
        height: 8px !important;
        min-width: 8px !important;
        padding: 0 !important;
    }

    .regular {
        font-size: 11px;
        min-width: 20px;
        height: 20px;
        padding: 0 4px;
    }

    .small {
        font-size: 10px;
        min-width: 16px;
        height: 16px;
        padding: 0 3px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Badge.vue